export default __webpack_public_path__ + "static/media/Logo Gualtieri White.c7b21018.svg";